module.exports = __webpack_public_path__ + "img/inspiration_collections@2x.543ef39.webp";